
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movie",
      function () {
        return require("private-next-pages/movie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movie"])
      });
    }
  